"use client";
import React from "react";
import Image from "next/image";
import { motion, Variants } from "framer-motion";

const mediaItems = [
  { src: "/images/dainik-jagran.png", alt: "Dainik Jagran" },
  { src: "/images/amar-ujala.png", alt: "Amar Ujala" },
  { src: "/images/hindustan.png", alt: "Hindustan" },
  { src: "/images/sahara.png", alt: "Sahara" },
];

const circulars = [
  {
    title: "Engineering First year and SIPS Mid term Examination Notice",
    date: "16/11/2021 - 31/12/2021",
  },
  {
    title: "Appointment of Departmental CoDs of CSE, ME ECE and EEE",
    date: "16/11/2021 - 30/11/2021",
  },
  {
    title: "Proctor Board Of Shivalik Group Of Institutions",
    date: "15/11/2021 - 30/06/2022",
  },
  {
    title: "NOTICE-FEE DEPOSIT FINAL REMINDER TO ALL STUDENTS OF SCE/SIPS/COP",
    date: "13/11/2021 - 30/06/2022",
  },
  {
    title: "Engineering First year and SIPS Mid term Examination Notice",
    date: "16/11/2021 - 31/12/2021",
  },
];

// Animation Variants
const fadeUp: Variants = {
  hidden: { opacity: 0, y: 40 },
  show: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.15, duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  }),
};

const MediaCoverage: React.FC = () => {
  return (
    <section
      className="relative min-h-screen bg-cover bg-center overflow-hidden"
      style={{ backgroundImage: "url('/bg-campus.jpg')" }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-[2px]" />

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 py-20 text-white">
        {/* Title Animation */}
        <motion.h2
          className="text-center text-4xl font-extrabold mb-14 tracking-wide"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          Media Coverage
        </motion.h2>

        {/* Media Logos */}
        <motion.div
          className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {mediaItems.map((item, index) => (
            <motion.div
              key={index}
              custom={index}
              variants={fadeUp}
              whileHover={{ scale: 1.05, rotate: 1 }}
              className="bg-white/90 rounded-2xl shadow-md hover:shadow-xl transition-all flex items-center justify-center p-6"
            >
              <Image
                src={item.src}
                alt={item.alt}
                width={180}
                height={80}
                className="object-contain"
              />
            </motion.div>
          ))}
        </motion.div>

        {/* Circular Notices Header */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          viewport={{ once: true }}
          className="bg-[#e61e55] rounded-t-2xl py-4"
        >
          <h2 className="text-center text-2xl md:text-3xl font-extrabold uppercase tracking-wide drop-shadow-lg">
            Circular Notices
          </h2>
        </motion.div>

        {/* Notices List */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          viewport={{ once: true }}
          className="bg-black/70 backdrop-blur-md rounded-b-2xl overflow-y-auto max-h-[320px]"
        >
          <ul>
            {circulars.map((notice, index) => (
              <motion.li
                key={index}
                custom={index}
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                className="flex justify-between items-center border-b border-gray-700 px-6 py-3 hover:bg-white/10 transition-all duration-300"
              >
                <span className="text-sm md:text-base text-gray-200 font-medium">
                  {notice.title}
                </span>
                <span className="text-xs md:text-sm text-gray-400">
                  {notice.date}
                </span>
              </motion.li>
            ))}
          </ul>
        </motion.div>
      </div>

      {/* Floating Blur Decoration */}
      <motion.div
        className="absolute top-1/4 left-10 w-60 h-60 bg-pink-500/20 rounded-full blur-3xl"
        animate={{ y: [0, 20, 0], x: [0, 10, 0] }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute bottom-10 right-20 w-52 h-52 bg-blue-500/20 rounded-full blur-3xl"
        animate={{ y: [0, -15, 0], x: [0, -10, 0] }}
        transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
      />
    </section>
  );
};

export default MediaCoverage;
